import apiSlice from "./ApiSlice";

export const webcourseApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL JOB WITH PAGINATION
    getAllWebcourseWithPagination: builder.query({
      providesTags: ["web-course"],
      query: (body) => {
        return {
          url: "/web-course",
          method: "POST",
          body,
        };
      },
    }),
    // Add
    addWebcourse: builder.mutation({
      invalidatesTags: ["web-course"],
      query: (body) => {
        return {
          url: "/web-course/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteWebcourse: builder.mutation({
      invalidatesTags: ["web-course"],
      query: ({ id }) => {
        return {
          url: `/web-course/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET JOB BY ID
    getWebcourseById: builder.query({
      providesTags: ["web-course"],
      query: (id) => {
        return {
          url: `/web-course/get-by-id/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editWebcourse: builder.mutation({
      invalidatesTags: ["web-course"],
      query: ({ body, id }) => {
        return {
          url: `/web-course/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetAllWebcourseWithPaginationQuery,
  useAddWebcourseMutation,
  useDeleteWebcourseMutation,
  useEditWebcourseMutation,
  useGetWebcourseByIdQuery,
} = webcourseApi;
